import { NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS, NOTIFICATION_CREATE_EMAIL_CAMPAIGN } from '../../config/notifications';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from '../layout/Dashboard';
import { Messages } from "../../components/layout/Messages/Messages";
import { EmailCampaignTable } from "../../components/pages/emailCampaigns/EmailCampaignTable";
import { CreateEmailCampaign } from "../../components/pages/emailCampaigns/actionButtons/CreateEmailCampaign";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './EmailCampaignManagement.scss';

function EmailCampaignManagementComponent(props) {

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title" />}
      workspace
      {...props}
    >
      <PageWorkspace className="email-campaigns-list-workspace">
        <PageHeader
          actions={<CreateEmailCampaign/>}
          title={<FormattedMessage id="pages.emailCampaigns.emailCampaignManagement.title" />}
        />
        <div className="email-campaigns-list-notifications">
          <Messages/>
          <Messages notificationId={ NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS }/>
          <Messages notificationId={ NOTIFICATION_CREATE_EMAIL_CAMPAIGN }/>
        </div>
        <PageSurface className="email-campaigns-list-surface">
          <EmailCampaignTable />
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

const EmailCampaignManagement = connect(null, { hideNotification })(EmailCampaignManagementComponent);

export { EmailCampaignManagement, EmailCampaignManagementComponent };
